import { render, staticRenderFns } from "./StackedTable.vue?vue&type=template&id=34c0ef01&"
import script from "./StackedTable.vue?vue&type=script&lang=js&"
export * from "./StackedTable.vue?vue&type=script&lang=js&"
import style0 from "./StackedTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports